import React from "react";

const View = ({color = "currentColor", ...props}) => (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M21.7629 10.9097C22.5795 11.8386 22.5795 13.1614 21.7629 14.0903C20.1777 15.8934 17.2397 18.25 12.6776 18.25C8.11562 18.25 5.17758 15.8934 3.59237 14.0903C2.77578 13.1614 2.77578 11.8386 3.59237 10.9097C5.17759 9.1066 8.11563 6.75 12.6776 6.75C17.2397 6.75 20.1777 9.1066 21.7629 10.9097Z"
            stroke={color}
            strokeWidth="1.5"
        />
        <circle cx="12.7848" cy="12.5" r="3" stroke={color} strokeWidth="1.5" />
    </svg>
);

export default View;
